import { useState } from 'react'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import Card from './Card'

export default function CarouselCards({ items = [], cardsPerPage = 3, renderCard }) {
    const [currentPage, setCurrentPage] = useState(0)
    const totalPages = Math.ceil(items.length / cardsPerPage)

    const handlePrev = () => {
        setCurrentPage(prev => (prev > 0 ? prev - 1 : totalPages - 1))
    }

    const handleNext = () => {
        setCurrentPage(prev => (prev < totalPages - 1 ? prev + 1 : 0))
    }

    const startIndex = currentPage * cardsPerPage
    const visibleItems = items.slice(startIndex, startIndex + cardsPerPage)

    return (
        <div className='relative w-full'>
            {/* Nav Buttons */}
            <button
                onClick={handlePrev}
                className='absolute p-2 transform -translate-y-1/2 bg-white rounded-full sm:p-3 left-2 top-1/2 bg-opacity-60 hover:bg-opacity-80'
            >
                <FaChevronLeft className='text-lg text-black sm:text-xl' />
            </button>
            <button
                onClick={handleNext}
                className='absolute p-2 transform -translate-y-1/2 bg-white rounded-full sm:p-3 right-2 top-1/2 bg-opacity-60 hover:bg-opacity-80'
            >
                <FaChevronRight className='text-lg text-black sm:text-xl' />
            </button>

            {/* Card Group */}
            <div className='grid grid-cols-1 gap-4 px-4 transition-all duration-300 ease-in-out sm:px-8 md:px-14 sm:grid-cols-2 md:grid-cols-3'>
                {visibleItems.map((item, idx) => (
                    <Card
                        key={idx}
                        imageSrc={item.imageSrc}
                        label={item.label}
                        description={item.description}
                        buttonLabel={item.buttonLabel}
                        onButtonClick={item.onButtonClick}
                        buttonVariant={item.buttonVariant}
                        buttonSize={item.buttonSize}
                    >
                        {item.children}
                    </Card>
                ))}
            </div>

            {/* Dots */}
            <div className='flex justify-center gap-2 mt-4 sm:gap-4'>
                {Array.from({ length: totalPages }).map((_, index) => (
                    <button
                        key={index}
                        onClick={() => setCurrentPage(index)}
                        className={`h-2.5 w-2.5 sm:h-4 sm:w-4 rounded-full transition-colors ${
                            index === currentPage ? 'bg-yellow-500' : 'bg-gray-300'
                        }`}
                    />
                ))}
            </div>
        </div>
    )
}
